import { createFetcher } from '../../Common';

import { getBaseUrl, PANEL_REPORTS_ENDPOINT } from '../../constants';

import { panelQueryBuilder } from './panelUtils';

export class PanelReports {
  static getInstance() {
    if (!this.instance) {
      this.instance = new PanelReports(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.endpoint = PANEL_REPORTS_ENDPOINT;
    this.fetcher = fetcher;
  }

  get base_url() {
    return getBaseUrl();
  }

  async getAllPanelReports(req) {
    const queryString = panelQueryBuilder(req);
    const url = `${this.base_url}${this.endpoint}${queryString}`;
    const response = await this.fetcher.getData(url);
    return { data: response?.data, meta: response?.meta };
  }
}

export const createPanelReports = () => PanelReports.getInstance();
